import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import PopperMenu from '@/modules/base/components/popper-menu/popper-menu'
import lang from '@/lang'

const useStyles = makeStyles(theme => ({
  container: {
    paddingRight: 5,
    ...theme.mixins.truncateText,
  },
  elementLink: {
    color: theme.textColor,
  },
  popperContent: {
    padding: 16,
    '& a, & span': {
      display: 'block',
    },
  },
}))

const MultipleListing = (props) => {
  const {
    title,
    count,
    elements,
    customContent,
    customActiveElement,
    tooltipLabel,
    className,
    styles,
    onClick,
  } = props
  const classes = useStyles(props)

  const [popperOpen, setPopperOpen] = useState(false)

  const list = elements.slice(0, count)
  const tooltip = elements.slice(count)

  const linkRef = useRef()

  const Element = (props) => {
    const { entry } = props
    const text = buildName(entry)

    if (onClick) {
      return <a className={classes.elementLink} onClick={() => onClick(entry)}>{text}</a>
    } else {
      return <span>{text}</span>
    }
  }

  const buildName = (object) => {
    return object?.name
      ? object.name
      : ((object?.firstName || object?.lastName)
        ? `${object?.firstName} ${object?.lastName}`
        : object?.email || object?.invitationEmail)
  }

  const activeElementClass = clsx(styles?.activeElement && styles.activeElement)
  const tooltipLabelClass = clsx(styles?.tooltipLabel && styles.tooltipLabel)
  return (
    <div className={clsx(classes.container, className)}>
      {title ? `${title}: ` : ''}
      <span className={activeElementClass}>
        {customActiveElement ?? <Element entry={list[0]} />}
        {
          Boolean(tooltip.length) && (
            <>
              <a
                ref={linkRef}
                className={tooltipLabelClass}
                onClick={() => setPopperOpen(!popperOpen)}>
                {` +${tooltip.length} ${tooltipLabel}`}
              </a>
              <PopperMenu
                open={popperOpen}
                elementRef={linkRef}
                style={{ popperContent: classes.popperContent }}
                onClose={() => setPopperOpen(false)}
                arrow
              >
                {customContent ?? tooltip.map(entry => (<Element entry={entry} />))}
              </PopperMenu>
            </>
          )
        }
      </span>
    </div>
  )
}

MultipleListing.propTypes = {
  title: PropTypes.string,
  count: PropTypes.number,
  tooltipLabel: PropTypes.string,
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    }),
  ),
  customContent: PropTypes.children,
  customActiveElement: PropTypes.node,
  className: PropTypes.string,
  styles: PropTypes.shape({
    activeElement: PropTypes.string,
    tooltipLabel: PropTypes.string,
  }),
}

MultipleListing.defaultProps = {
  title: undefined,
  count: 1,
  className: undefined,
  tooltipLabel: lang.generics.more,
}

export default MultipleListing
